export default __webpack_public_path__ + "static/media/book-placeholder.30e70175.svg";